import SelectDropdown from 'src/components/atomsLegacy/SelectDropdown/SelectDropdown';
import styled from 'styled-components';

export const DataIntegrationContainer = styled.div`
  background: white;
  height: 100%;
  padding: 24px;
`;

export const DataIntegrationDescription = styled.p``;

export const SettingsContainer = styled.div`
  padding: 20px 0;
`;

export const ConfirmDialogBody = styled.div``;

export const ConfirmDialogDescription = styled.p``;

export const ConfirmDialogQuestion = styled.p`
  margin-top: 60px;
`;

export const StyledSelectDropdown = styled(SelectDropdown)`
  @media (max-width: 520px) {
    min-width: 200px;
    width: 90%;
  }
`;
